export const openInWebview=()=>{
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) === 'micromessenger') { // 微信浏览器判断
        return false
    } else if (ua.match(/QQ/i) ==='qq') { // QQ浏览器判断
        return false
    } else if (ua.match(/WeiBo/i) === "weibo") {
        return false
    } else {
        if (ua.match(/Android/i) !== null) {
            return ua.match(/browser/i) === null
        } else if (ua.match(/iPhone/i) !== null) {
            return ua.match(/safari/i) === null
        } else {
            return (ua.match(/macintosh/i) === null && ua.match(/windows/i) === null)
        }
    }
}  
export const inBrowser = typeof window !== 'undefined';
export const UA = inBrowser && window.navigator.userAgent.toLowerCase();
export const isIE = UA && /msie|trident/.test(UA);
export const isIE9 = UA && UA.indexOf('msie 9.0') > 0;
export const isEdge = UA && UA.indexOf('edge/') > 0;
export const isAndroid = (UA && UA.indexOf('android') > 0);
export const isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA));
export const isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
export const isWeixin = UA && UA.indexOf('micromessenger') > 0;